var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/role";
export default class RoleService {
    /**
     * @deprecated - use search
     */
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/roles/search/findByNameLike", {
                params: { sort: "name", order: "ASC", size: 50, search },
            });
            return response.data._embedded.roles;
        });
    }
    /**
     * @deprecated - use search
     */
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/roles/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.roles;
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            groupIds: search.groupIds,
            name: search.name,
            isDefault: search.isDefault,
            isDeleted: search.isDeleted,
            integrationId: search.integrationId,
            createdByPersonIds: search.createdByPersonIds,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
    static currentUserIsStaff() {
        return FetchService.getSingleResponse(BASE_URL + "/currentUserIsStaff");
    }
}
